


















import Vue from 'vue';
import { IProduct } from '@/common/interfaces/products.interface';
import ProductHelper from '@/helpers/ProductHelper';
import { ICalendarDoorProduct } from '@/common/interfaces/announcement-bar.interface';

export default Vue.extend({
  name: `PriceText`,
  computed: {
    discountPrice(): string {
      return ProductHelper.getMyPrice(this.productInfo, this.isPartner);
    },

    price(): string {
      return ProductHelper.getMyOriginalPrice(this.productInfo, this.isPartner);
    },
  },
  props: {
    isPartner: {
      required: true,
      type: Boolean,
    },
    productInfo: {
      required: true,
      type: Object as () => IProduct | ICalendarDoorProduct,
    },
    small: {
      default: false,
      type: Boolean,
    },
  },
});
